import { useState } from 'react';
import { useCart } from '../../hooks/useCart';
import { Link } from 'react-router-dom';

export default function ProduitBougieLivrePlieSansLed() {
  const { addToCart } = useCart();
  const [quantity, setQuantity] = useState(1);

  const product = {
    id: 'bougie-sans-led',
    name: 'Bougie en livre plié — Sans LED',
    price: 30,
    originalPrice: null,
    images: [
      'https://static.readdy.ai/image/fd456b0d540e8f517714341c204b3126/b25886b6d5302fa4fce5dc966e858d39.png'
    ],
    description:
      "Bougie décorative réalisée à partir d'un véritable livre ancien plié à la main. Version classique avec bougie traditionnelle. Chaque pièce est unique et ornée d'un ruban délicat. Une création poétique qui apporte une touche chaleureuse à votre intérieur.",
    features: [
      'Fait main à partir de livres anciens',
      'Bougie traditionnelle incluse',
      'Chaque pièce est unique',
      "Ornée d'un ruban délicat",
      'Création artisanale française',
      'Parfait pour la décoration de Noël'
    ],
    category: 'Collection de Noël',
    subcategory: 'Bougies en livres pliés'
  };

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleAddToCart = () => {
    try {
      addToCart(
        {
          id: product.id,
          name: product.name,
          price: product.price,
          image: product.images[0],
          description: product.description,
          link: `/produit-bougie-livre-plie-sans-led`
        },
        quantity
      );
    } catch (e) {
      console.error('Erreur lors de l\'ajout au panier :', e);
      // Optionally, display a user‑friendly message here
      return;
    }

    // Feedback visuel
    const button = document.querySelector('.add-to-cart-btn') as HTMLButtonElement;
    if (button) {
      const originalText = button.innerHTML;
      button.innerHTML = '<i class="ri-check-line mr-2"></i>Ajouté au panier !';
      button.disabled = true;
      setTimeout(() => {
        button.innerHTML = originalText;
        button.disabled = false;
      }, 2000);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8EDEA]">
      {/* Breadcrumb */}
      <div className="bg-[#FAF9F8] py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex items-center space-x-2 text-sm">
            <Link to="/" className="text-[#B97A72] hover:text-[#C49B86]">
              Accueil
            </Link>
            <i className="ri-arrow-right-s-line text-[#6B5E5A]"></i>
            <Link to="/boutique" className="text-[#B97A72] hover:text-[#C49B86]">
              Boutique
            </Link>
            <i className="ri-arrow-right-s-line text-[#6B5E5A]"></i>
            <span className="text-[#6B5E5A]">{product.name}</span>
          </nav>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Images produit */}
          <div className="space-y-4">
            <div className="aspect-square bg-[#F3D9D9] rounded-lg overflow-hidden">
              {product.images[currentImageIndex] ? (
                <img
                  src={product.images[currentImageIndex]}
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-[#6B5E5A]">
                  <div className="text-center">
                    <i className="ri-image-line text-6xl text-[#C49B86] mb-4"></i>
                    <p>Image à venir</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Informations produit */}
          <div className="space-y-6">
            <div>
              <span
                className="text-sm text-[#B97A72] font-medium"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                {product.subcategory}
              </span>
              <h1
                className="text-4xl font-bold text-[#6B5E5A] mt-2"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                {product.name}
              </h1>
            </div>

            <div className="flex items-center space-x-4">
              <span
                className="text-3xl font-bold text-[#B97A72]"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                {product.price}€
              </span>
              {product.originalPrice && (
                <span className="text-xl text-[#6B5E5A] line-through">
                  {product.originalPrice}€
                </span>
              )}
            </div>

            <p
              className="text-[#6B5E5A] leading-relaxed"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {product.description}
            </p>

            {/* Caractéristiques */}
            <div className="bg-[#FAF9F8] border-2 border-[#B97A72] rounded-lg p-6">
              <h3
                className="text-lg font-semibold text-[#6B5E5A] mb-4"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                Caractéristiques
              </h3>
              <ul className="space-y-2">
                {product.features.map((feature, index) => (
                  <li
                    key={index}
                    className="flex items-center text-[#6B5E5A]"
                    style={{ fontFamily: 'Poppins, sans-serif' }}
                  >
                    <i className="ri-check-line text-[#B97A72] mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>

            {/* Quantité et ajout au panier */}
            <div className="space-y-4">
              <div>
                <label
                  className="block text-sm font-medium text-[#6B5E5A] mb-2"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  Quantité
                </label>
                <div className="flex items-center space-x-3">
                  <button
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    className="w-10 h-10 flex items-center justify-center border-2 border-[#B97A72] text-[#B97A72] rounded-lg hover:bg-[#B97A72] hover:text-white transition-colors"
                  >
                    <i className="ri-subtract-line"></i>
                  </button>
                  <span className="text-xl font-semibold text-[#6B5E5A] min-w-[3rem] text-center">
                    {quantity}
                  </span>
                  <button
                    onClick={() => setQuantity(quantity + 1)}
                    className="w-10 h-10 flex items-center justify-center border-2 border-[#B97A72] text-[#B97A72] rounded-lg hover:bg-[#B97A72] hover:text-white transition-colors"
                  >
                    <i className="ri-add-line"></i>
                  </button>
                </div>
              </div>

              <button
                onClick={handleAddToCart}
                className="add-to-cart-btn w-full bg-[#B97A72] text-white py-4 rounded-lg hover:bg-[#C49B86] transition-colors text-lg font-medium whitespace-nowrap"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                <i className="ri-shopping-cart-line mr-2"></i>
                Ajouter au panier
              </button>
            </div>

            {/* Informations de livraison */}
            <div className="bg-[#EBD2CF] rounded-lg p-4">
              <div className="flex items-center space-x-3 text-[#6B5E5A]">
                <i className="ri-truck-line text-[#B97A72]"></i>
                <span
                  className="text-sm"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  Livraison gratuite à partir de15 € d'achat
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}